import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import TruncatedGridCell from "../components/TruncatedGridCell";

/**
 * Creates a basic grid column definition with truncated text rendering.
 * This helper reduces boilerplate when creating columns that only need text truncation.
 *
 * @param field - The field name for the column
 * @param headerName - The display name for the column header
 * @param options - Additional column options (flex, width, etc.)
 * @returns GridColDef with truncated text rendering
 */
export const createTruncatedColumn = (
  field: string,
  headerName: string,
  options: Partial<GridColDef> = {}
): GridColDef => ({
  field,
  headerName,
  disableColumnMenu: true,
  flex: 0.9,
  ...options,
  renderCell: (params: GridRenderCellParams<string>) => {
    const value = params.value as string;
    return <TruncatedGridCell value={value} placement="top-start" />;
  },
});

export default createTruncatedColumn;
